<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <Breadcrumb class="breadcrumb" :breadcrumbItems="breadCrumbItems" />
    <div class="d-flex flex-column container align-center mt-8">
      <div class="d-flex flex-sm-row flex-column container">
        <v-file-input
          v-model="input"
          label="Αρχείο έκθεσης"
          class="rounded text-body-1 font-weight-regular input mr-2"
          solo
          accept="application/xml"
          :error-messages="inputErrors"
        ></v-file-input>

        <v-select
          v-model="year"
          label="Έτος"
          :items="years"
          class="rounded text-body-1 font-weight-regular mr-4"
          solo
          :error-messages="yearErrors"
        ></v-select>
      </div>

      <!-- <v-row v-for="(input, i) in payload" :key="i">
        <v-col cols="12" sm="4">
          <v-select
            v-model="input.year"
            label="Έτος"
            :items="years[i]"
            class="rounded text-body-1 font-weight-regular mr-4"
            solo
            :error-messages="yearErrors(i)"
            @change="getPeriods(i)"
            :disabled="i > 0"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="4">
          <v-select
            v-model="input.period"
            label="Περίοδος"
            :items="input.periods"
            class="rounded text-body-1 font-weight-regular mr-4"
            solo
            item-text="reportPeriodName"
            item-value="reportPeriodId"
            :error-messages="periodErrors(i)"
            :loading="input.periodLoader"
            :disabled="input.periodLoader"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="4">
          <v-select
            v-model="input.fund"
            label="Κεφάλαιο"
            :items="funds"
            class="rounded text-body-1 font-weight-regular"
            solo
            item-text="mmfNationalName"
            item-value="mmfId"
            width="300px"
            :error-messages="fundErrors(i)"
          ></v-select>
        </v-col>
      </v-row>

      <div class="mb-sm-16 align-self-end">
        <v-btn @click="onAdd" icon
          ><v-icon color="success"> mdi-plus</v-icon></v-btn
        >
        <v-btn @click="onRemove" :disabled="payload.length == 1" icon
          ><v-icon color="error"> mdi-minus</v-icon></v-btn
        >
      </div> -->

      <div class="d-flex flex-sm-row flex-column justify-center">
        <v-btn
          class="
            success
            mr-sm-10
            mb-sm-0 mb-2
            rounded
            text-lowercase text-sm-body-1
            font-weight-regular
            button
          "
          @click="onSubmit()"
          :loading="loader"
          >Επαλήθευση
        </v-btn>

        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular button"
          to="/employees/"
          >Άκυρο
        </v-btn>
      </div>
    </div>
    <Alert v-if="alert" class="mt-16" :items="alertItems"></Alert>
  </div>
</template>

<script>
import Alert from "../../components/Alert";
import Breadcrumb from "../../components/Breadcrumb.vue";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import axios from "axios";

const zip = (value) => {
  if (typeof value.name != "undefined") {
    if (value.name != null) {
      const [extension] = value.name.split(".").reverse();
      if (extension === "xml") return value;
      else return false;
    } else return false;
  } else return false;
};

export default {
  components: {
    Alert,
    Breadcrumb,
  },

  async created() {
    try {
      console.log(this.currentReport);
      const res = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/CredInst/GetFunds`
      );
      this.funds = res.data.funds;
    } catch (e) {
      console.log(e);
    }
  },

  async mounted() {
    await this.onAdd();
  },

  data() {
    return {
      input: [],
      loader: false,
      alert: false,
      year: null,

      payload: [],

      years: ["2020", "2021", "2022", "2023", "2024", "2025", "2026"],

      funds: [
        {
          text: "Κεφάλαιο 1",
          id: 1,
        },
        {
          text: "Κεφάλαιο 2",
          id: 2,
        },

        {
          text: "Κεφάλαιο 3",
          id: 3,
        },
      ],

      alertItems: {
        strong_text: "Προσοχή! ",
        text: "",
        text_color: "error",
        dismissable: false,
        width: "950px",
      },

      breadCrumbItems: [
        {
          text: "Αρχική",
          disabled: false,
          to: "/employess",
        },
        {
          text: `Νέα έκδοση`,
          disabled: true,
          to: `${this.$route.path}`,
        },
      ],
    };
  },

  validations: {
    input: { required },
  },

  computed: {
    inputErrors() {
      const errors = [];
      if (!this.$v.input.$dirty) return errors;
      if (!this.$v.input.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    yearErrors() {
      const errors = [];
      if (!this.$v.year.$dirty) return errors;
      if (!this.$v.year.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    ...mapState({
      currentReport: (state) => state.reports.currentReport,
    }),
  },

  methods: {
    async onAdd() {
      try {
        if (this.payload.length > 1) {
          this.payload.push({
            year: `${this.payload[0].year}`,
            period: null,
            fund: null,
            periods: [],
            periodLoader: false,
          });
        } else {
          this.payload.push({
            year: null,
            period: null,
            fund: null,
            periods: [],
            periodLoader: false,
          });
        }

        this.years.push([
          "2020",
          "2021",
          "2022",
          "2023",
          "2024",
          "2025",
          "2026",
        ]);
        await this.getPeriods(this.payload.length - 1);
      } catch (e) {
        console.log(e);
      }
    },

    onRemove() {
      this.payload.pop();
      this.years.pop();
    },

    async getPeriods(i) {
      try {
        this.payload[i].periodLoader = true;
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/System/GetPeriodsbyYear/${this.payload[i].year}`
        );
        this.payload[i].period = null;
        this.payload[i].periods = res.data;

        this.payload[i].periodLoader = false;
      } catch (e) {
        console.log(e);
      }
    },

    async onSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        const payload = this.payload.map((el) => {
          return {
            period: el.period,
            fund: el.fund,
            year: el.year,
          };
        });

        // console.log(payload);

        const formData = new FormData();

        // for (let i = 0; i < payload.length; i++) {
        //   formData.set(
        //     `fundSubmissionModels[${i.toString()}].periodId`,
        //     this.payload[i].period
        //   );
        //   formData.set(
        //     `fundSubmissionModels[${i.toString()}].fund`,
        //     this.payload[i].fund
        //   );
        //   formData.set(
        //     `fundSubmissionModels[${i.toString()}].year`,
        //     this.payload[i].year
        //   );
        // }

        formData.set("reportPeriodId", this.currentReport.reportPeriodId);
        formData.set("reportPeriodName", this.currentReport.reportPeriodName);
        formData.set("xmlFile", this.input);
        formData.set("year", this.year);

        // for (var pair of formData.entries()) {
        //   console.log(pair[0] + ", " + pair[1]);
        // }

        this.loader = true;

        // const res = await axios.post(
        //   `${process.env.VUE_APP_BASE_URL}/CredInst/ValidateReport`,
        //   formData
        // );
        // console.log(res);
        await this.uploadReport(formData);
        this.loader = false;
        this.$router.push("/employees/new/validation");
      } catch (e) {
        this.loader = false;
        if (
          e.response.data.errorMessage == "Storage error.|File already exists."
        )
          this.alertItems.text =
            "Δεν μπορείτε να υποβάλεται ξανά έκθεση με το ίδιο όνομα αρχείου.";
        else if (
          e.response.data.errorMessage ==
          "Storage error.|The file contains no or more than 1 XML file."
        )
          this.alertItems.text = "Το αρχείο ZIP δεν περιέχει XML.";
        else if (
          e.response.data.errorMessage ==
          "Storage error.|The name of the XML file is not consistent with the name of its container ZIP file"
        )
          this.alertItems.text =
            "Προσοχή το όνομα του αρχείου XML δεν είναι ίδιο με το όνομα του ZIP αρχείου.";
        this.alert = true;
      }
    },

    // yearErrors(i) {
    //   const errors = [];
    //   if (!this.$v.payload.$each[i].year.$dirty) return errors;
    //   if (!this.$v.payload.$each[i].year.required)
    //     errors.push("Υποχρεωτικό πεδίο");
    //   return errors;
    // },

    // periodErrors(i) {
    //   const errors = [];
    //   if (!this.$v.payload.$each[i].period.$dirty) return errors;
    //   if (!this.$v.payload.$each[i].period.required)
    //     errors.push("Υποχρεωτικό πεδίο");
    //   return errors;
    // },

    // fundErrors(i) {
    //   const errors = [];
    //   if (!this.$v.payload.$each[i].fund.$dirty) return errors;
    //   if (!this.$v.payload.$each[i].fund.required)
    //     errors.push("Υποχρεωτικό πεδίο");
    //   return errors;
    // },

    ...mapActions(["uploadReport"]),
  },
};
</script>

<style scoped lang="scss">
.container,
.breadcrumb {
  width: 950px;
}

.funds {
  width: 37%;
}

.select {
  width: 37.5%;
}

.input {
  width: 62.5%;
}

// 37.5 62,5
@media only screen and (max-width: 960px) {
  .container,
  .breadcrumb {
    width: 800px;
  }
}

@media only screen and (max-width: 600px) {
  .container,
  .breadcrumb {
    width: 100%;
  }

  .button {
    width: 280px;
  }

  .select,
  .input {
    width: 100%;
  }
}
</style>
